import React, { useState } from 'react';
import AdminHeader from './Header';
import '../../styles/Message.css';

function MessageManagement() {
    const [message, setMessage] = useState({
        id: '',
        title: '',
        content: '',
        image: '',
        type: '',
        createdAt: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMessage(prevState => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log("Message Data Submitted", message);
    };

    return (
        <AdminHeader>
        <div className="fixed-top-bar">
        <form onSubmit={handleSubmit}>
            <h1>Message Management</h1>
            <div className="form-group">
            <div className="row my-2">
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="title" className="small">Id: </label>
            <input className="form-control" value={message.id} onChange={handleChange} placeholder="Message ID" />
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            <label htmlFor="title" className="small">Title: </label>
            <input className="title" value={message.title} onChange={handleChange} placeholder="Title" />
            </div>
            </div>
            <div className="row my-2">
            <div className="col-6 col-md-6 col-xl-4">
            <label htmlFor="content" className="small">Content: </label>
            <textarea className="form-control" value={message.content} onChange={handleChange} placeholder="Content" />
            </div>
            <div className="col-6">
            <label htmlFor="image" className="small">Image: </label>
            <input type="file" className="image" value={message.image} onChange={handleChange} placeholder="Image URL" />
            </div>
            <div className="col-12 col-md-6 col-xl-4">
            {/* <label htmlFor="type" className="small">Type: </label>
            <input name="type" value={message.type} onChange={handleChange} placeholder="Type" /><br/> */}
            <button type="submit">Submit</button>
            </div>
            </div>
            </div>
        </form>
        </div>
        </AdminHeader>

    );
}

export default MessageManagement;